(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.header__heading-logo-wrapper,.luma-hero-cta__secondary-position').forEach(wrapper => {
    const image = wrapper.querySelector('.header__heading-logo,img.luma-hero-cta__secondary-image');
    if (!image) return;
    const technical = image.matches('.luma-hero-cta__secondary-image');
    const shine = document.createElement('span');
    shine.className = technical ? 'luma-logo-shine luma-technical-shine luma-hero-cta__secondary-image' : 'luma-logo-shine';
    if (technical) shine.style.opacity = '0';
    shine.setAttribute('aria-hidden', 'true');
    wrapper.append(shine);
    let tint;
    if (technical && image.src.includes('OSD_overlay_Main')) {
      tint = document.createElement('span');
      tint.className = 'luma-technical-tint luma-hero-cta__secondary-image';
      tint.setAttribute('aria-hidden', 'true');
      wrapper.insertBefore(tint, shine);
      image.style.visibility = 'hidden';
    }
    const rgbLayers = tint ? ['red', 'green', 'blue'].map(colour => {
      const layer = document.createElement('span');
      layer.className = 'luma-osd-rgb luma-osd-rgb--' + colour + ' luma-hero-cta__secondary-image';
      layer.setAttribute('aria-hidden', 'true');
      wrapper.insertBefore(layer, shine);
      return layer;
    }) : [];
    const updateMask = () => {
      const mask = `url("${image.currentSrc || image.src}")`;
      shine.style.setProperty('--luma-logo-mask', mask);
      if (tint) tint.style.setProperty('--luma-logo-mask', mask);
      rgbLayers.forEach(layer => layer.style.setProperty('--luma-logo-mask', mask));
    };
    updateMask(); image.addEventListener('load', updateMask);
    let timer, finish;
    const stop = () => { clearTimeout(timer); clearTimeout(finish); shine.classList.remove('is-shining'); };
    const schedule = () => {
      if (motion.matches || document.hidden) return;
      timer = setTimeout(() => {
        shine.classList.add('is-shining');
        finish = setTimeout(() => shine.classList.remove('is-shining'), 1400);
        schedule();
      }, 6000 + Math.random() * 6000);
    };
    const restart = () => { stop(); schedule(); };
    motion.addEventListener('change', restart);
    document.addEventListener('visibilitychange', restart);
    schedule();
    if (tint) {
      let glitchTimer, glitchFinish;
      const stopGlitch = () => {
        clearTimeout(glitchTimer);
        clearTimeout(glitchFinish);
        wrapper.classList.remove('is-osd-glitch');
      };
      const scheduleGlitch = () => {
        if (motion.matches || document.hidden || !wrapper.isConnected) return;
        glitchTimer = setTimeout(() => {
          const bounds = tint.getBoundingClientRect();
          if (bounds.bottom > 0 && bounds.top < innerHeight && bounds.right > 0 && bounds.left < innerWidth) {
            wrapper.classList.add('is-osd-glitch');
            glitchFinish = setTimeout(() => wrapper.classList.remove('is-osd-glitch'), 720);
          }
          scheduleGlitch();
        }, 10000 + Math.random() * 14000);
      };
      const restartGlitch = () => { stopGlitch(); scheduleGlitch(); };
      motion.addEventListener('change', restartGlitch);
      document.addEventListener('visibilitychange', restartGlitch);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(wrapper)) stopGlitch();
      });
      scheduleGlitch();
    }
  });
})();
